export default __webpack_public_path__ + "media/transfer-bubble/arrow-white-8f4916b5.svg";